import { Sparkles } from 'lucide-react';
import Modal from './Modal';
import { WHATS_NEW } from '../lib/whatsNew';

/* What's New dialog — the full release history, newest first, with the
   running release badged. Presentational: ProjectHeader owns when it opens
   (auto-pop once per unseen release, or on demand via the version badge /
   user-menu item) and what the footer buttons persist. */
export default function WhatsNewModal({
  open,
  onClose,
  onDismiss,
  currentVersion,
}: {
  open: boolean;
  /** close for this visit only — auto-pop may return next visit */
  onClose: () => void;
  /** mark the newest release as seen (persisted) and close */
  onDismiss: () => void;
  currentVersion?: string | null;
}) {
  if (!open) return null;

  return (
    <Modal
      open
      onClose={onClose}
      title={
        <span className="inline-flex items-center gap-2">
          <Sparkles className="w-4 h-4" style={{ color: 'var(--scpa-primary)' }} />
          What&apos;s new in ctTicketing
        </span>
      }
      width={560}
      footer={
        <>
          <button type="button" className="btn btn-ghost" onClick={onClose}>
            Remind me next time
          </button>
          <button type="button" className="btn btn-primary" onClick={onDismiss}>
            Got it
          </button>
        </>
      }
    >
      <div className="flex flex-col gap-5" style={{ maxHeight: '60vh', overflowY: 'auto', paddingRight: 4 }}>
        {WHATS_NEW.map(entry => (
          <section key={entry.version}>
            <div className="flex items-baseline gap-2 mb-2">
              <h4 className="text-sm font-bold text-fg">Version {entry.version}</h4>
              {entry.version === currentVersion && (
                <span
                  className="text-[10px] font-semibold px-1.5 py-0.5 rounded-full"
                  style={{ background: 'var(--scpa-primary-muted)', color: 'var(--scpa-primary)' }}
                >
                  current
                </span>
              )}
              <span className="text-xs text-muted">{entry.date}</span>
            </div>
            <ul className="flex flex-col gap-2">
              {entry.highlights.map((h, i) => (
                <li key={i} className="flex gap-2 text-sm text-fg leading-relaxed">
                  <span
                    className="mt-1.5 w-1.5 h-1.5 rounded-full shrink-0"
                    style={{ background: 'var(--scpa-primary)' }}
                  />
                  <span>{h}</span>
                </li>
              ))}
            </ul>
          </section>
        ))}
      </div>
    </Modal>
  );
}
